import React, { useState } from "react";
import Btn from "../Button/Button";
import styles from "./FormStyle.module.scss";
import { motion } from "framer-motion";
import BackArrowSSO from "../../assets/svg/BackArrowSSO";
import ActivationCode from "../../components/ActivationCode/ActivationCode";

const pageVariants = {
    initial: {
        opacity: 0,
        y: 500,
        transition: {
            ease: "linear",
            duration: 0.3,
            delay: 0,
        },
    },
    in: {
        opacity: 1,
        y: 0,
        transition: {
            ease: "easeOut",
            duration: 0.5,
        },
    },
    out: {
        x: "100vw",
        transition: {
            ease: "easeInOut",
        },
    }
};

/**
 * A registration step component in the SSO flow where users choose between booking a call with a
 * QMENTA employee or entering an activation code if they are part of an existing study.
 *
 * @component
 *
 * @param {Object} props - Component props
 * @param {Function} props.showBookACallModal - Callback to open the "Book a Call" modal
 * @param {Function} props.onClickRegisterWithCode - Callback triggered when user tries to use an activation code
 * @param {Function} props.onClickLogIn - Callback triggered when user clicks the log in button
 *
 * @returns {JSX.Element} The rendered registration step two component
 */
const FormRegisterStepTwoSSO = ({ showBookACallModal, onClickRegisterWithCode, onClickLogIn }) => {

    const [showActivationCode, showActivationCodeSet ] = useState(false);

    return (
        <motion.div
            initial="initial"
            animate="in"
            exit="out"
            variants={pageVariants}
            className={styles.container}
            style={{ marginTop: 0, paddingTop: 0, width: "100%" }}
        >
            <div className={styles.registrationRightSideContainer}>
                {/* Back button */}
                <div style={{ visibility: showActivationCode ? "visible" : "hidden" }}>
                    <div onClick={() => showActivationCodeSet(false)} className={styles.kcBackContainer}>
                        <div className={styles.kcBackArrow}>
                            <BackArrowSSO />
                        </div>
                        <h3 className={styles.kcBackArrowText}>
                            Back to confirmation
                        </h3>
                    </div>
                </div>

                <h2 className={styles.formTitle}>Create an account</h2>

                <div style={{ display: showActivationCode ? "none" : "block" }}>
                    <p className={styles.formText}>Are you part of an existing study?</p>
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "16px", width: "100%", marginTop: "10px"}}>
                        <Btn stylebutton={"primary"} event={"No"} onClick={() => showBookACallModal()} />
                        <Btn stylebutton={"primary"} event={"Yes"} onClick={() => showActivationCodeSet(true)} />
                    </div>
                </div>

                {/* Set activation code view */}
                <div style={{ display: showActivationCode ? "block" : "none" }}>
                    <ActivationCode 
                        onClickRegisterWithCode={onClickRegisterWithCode}>    
                    </ActivationCode>
                </div>

                {/* Back to keycloak + support */}
                <div className={styles.containerOptionsLogindAndSupport}>
                    <div className={styles.formOptionLogin}>
                        <p>
                            Already have an account?
                            <button
                                className={styles.kcTextButton}
                                onClick={() => {onClickLogIn();}}
                            >
                                Log in
                            </button>
                        </p>
                    </div>
                    <div className={styles.formOptionSupport}>
                        <p>
                            If you have any issues, please contact <a href="mailto:support@qmenta.com">support@qmenta.com</a>
                        </p>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default FormRegisterStepTwoSSO;